import React, { useState, useEffect } from 'react';

const PopupImage = ({ src, onClose }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!src) return;

    const image = new Image();
    image.src = src;

    image.onload = () => {
      setLoading(false);
    };

    image.onerror = () => {
      setLoading(false); // вы также можете добавить обработку ошибок здесь
    };

    return () => {
      image.onload = null;
      image.onerror = null;
    };
  }, [src]);

  if (!src) {
    return null;
  }

  return (
    <div className={'popup-image'}>
      <div className={'popup-image-content'}>
        {loading ? (
          <div className="loader">Loading...</div> // замените это на вашу компоненту или стили лоадера
        ) : (
          <img src={src} alt="Popup Content" />
        )}
        <button className="btn btn-icon close-btn" onClick={onClose}>
          <span className="icon icon-plus"></span>
        </button>
      </div>
    </div>
  );
};

export default PopupImage;
